/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disabled[_ngcontent-%COMP%] {\r\n    display: none;\r\n}"];
export { styles as styles };
